export const CREATE = 'create';
export const LOGOUT = '/logout';
export const ROOT = '/';
export const PRODUCT_DETAILS = 'product/:productKey';
export const PRODUCT_DETAILS_ASSOCIATIONS = '';
export const PRODUCT_DETAILS_JOBS = 'ingestjobs';
export const PRODUCT_MATCHER_VALIDATIONS = 'matchervalidations';
export const PRODUCT_VISUALIZATIONS = 'visualizations';
export const PRODUCT_CONSOLIDATION = 'consolidation';
export const FULL_PRODUCT_VISUALIZATIONS = `${PRODUCT_MATCHER_VALIDATIONS}/${PRODUCT_VISUALIZATIONS}`;
export const PRODUCT_ASSOCIATION_CONFIG = '/product/:productKey/association/:associationId/configuration';
export const CREATE_PRODUCT_ASSOCIATION = 'product/:productKey/association/create';
export const INGEST_JOB_DETAILS = '/product/:productKey/ingestjobs/:ingestJobId';
export const VISUALIZATIONS_NAV_DETAILS = '/product/:productKey/visualizations';
export const RELEVANCE_TEST_DEFINITION_SEARCH = '/relevance-test';
export const RELEVANCE_TEST_DEFINITION_DETAILS = '/relevance-test/:testDefinitionId';
export const FORCED_RANKING_SEARCH = '/design-concept-forced-ranking';
export const FORCED_RANKING_DETAILS = '/design-concept-forced-ranking/:strategyName';
export const SETS_PLAYGROUND = '/sets-playground';
export const MATCHING_VISUALIZER = '/matching-visualizer';
export const SETS_CONFIG_SEARCH = '/sets-config';
export const SETS_CONFIG_DETAILS = '/sets-config/:productKey';
